const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const TOKEN_KEY = "asml_token";
export const CONN_ERR = "Unable to connect to server. Please try again in a moment.";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

function authHeader() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function apiGet(path) {
  let res;
  try {
    res = await fetch(`${API}${path}`, { headers: { ...authHeader() } });
  } catch (e) {
    throw new Error(CONN_ERR);
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(res.status >= 500 ? CONN_ERR : (data?.detail || "Request failed"));
  return data;
}

export async function apiSend(path, method, body) {
  let res;
  try {
    res = await fetch(`${API}${path}`, {
      method,
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new Error(CONN_ERR);
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(res.status >= 500 ? CONN_ERR : (data?.detail || "Request failed"));
  return data;
}

export async function uploadAudio(blob) {
  const form = new FormData();
  form.append("file", blob, "note.webm");
  const res = await fetch(`${API}/transcribe`, {
    method: "POST",
    headers: { ...authHeader() },
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.detail || "Transcription failed");
  return data.transcript;
}
